/**
 * Generated by '@kontent-ai/model-generator@7.4.0'
 */
export const contentTypes = {
    /**
     *    Configuration File
     */
    configuration_file: {
        codename: 'configuration_file',
        id: '7bb3ef7a-ece3-4b12-aef4-fdaef7f6a9b1',
        externalId: undefined,
        name: '🌍 Configuration File',
        elements: {
            /**
             * Administration Name (text)
             */
            administration_name: {
                codename: 'administration_name',
                id: '939f7764-78a4-4351-921c-a88c90dfb3ef',
                externalId: undefined,
                name: 'Administration Name',
                required: false,
                type: 'text'
            },

            /**
             * Allowed Forwarded Hosts (text)
             *
             * Comma separated domains
             */
            allowed_forwarded_hosts: {
                codename: 'allowed_forwarded_hosts',
                id: '423accd1-e51c-4bec-9e73-fdaf0397f6a8',
                externalId: undefined,
                name: 'Allowed Forwarded Hosts',
                required: false,
                type: 'text'
            },

            /**
             * Case Name (text)
             *
             * There can be more than one. Seperate multiple options with a pipe "|".
             */
            case_name: {
                codename: 'case_name',
                id: '53cb5478-d2b7-48ae-94bc-bb1371428373',
                externalId: undefined,
                name: 'Case Name',
                required: false,
                type: 'text'
            },

            /**
             * Case Number (text)
             *
             * There can be more than one. Seperate multiple options with a pipe "|".
             */
            case_number: {
                codename: 'case_number',
                id: '44186b12-62ec-4c3b-9859-bb6ea3270e0a',
                externalId: undefined,
                name: 'Case Number',
                required: false,
                type: 'text'
            },

            /**
             * Coming Soon Page (modular_content)
             */
            coming_soon_page: {
                codename: 'coming_soon_page',
                id: '1af5335e-b738-42ba-8521-2a42d52819ad',
                externalId: undefined,
                name: 'Coming Soon Page',
                required: false,
                type: 'modular_content'
            },

            /**
             * Content Alignment (multiple_choice)
             */
            content_alignment: {
                codename: 'content_alignment',
                id: 'fb1184d1-5729-411b-bd93-01213fc1d94a',
                externalId: undefined,
                name: 'Content Alignment',
                required: false,
                type: 'multiple_choice',
                options: {
                    left_aligned: {
                        name: 'Left Aligned',
                        id: '01bc8ada-0f16-4c8d-97bc-078abbd4ffda',
                        codename: 'left_aligned',
                        externalId: undefined
                    },
                    centered: {
                        name: 'Centered',
                        id: '74fcffda-98ab-46b9-baed-f25d09a818eb',
                        codename: 'centered',
                        externalId: undefined
                    },
                    justified: {
                        name: 'Justified',
                        id: 'd8a7f8f0-00c7-4236-a766-a1b025878c59',
                        codename: 'justified',
                        externalId: undefined
                    }
                }
            },

            /**
             * Cookie Banner (modular_content)
             */
            cookie_banner: {
                codename: 'cookie_banner',
                id: '4b4eccb2-fdec-48a6-b000-30c9bb6ffdc4',
                externalId: undefined,
                name: 'Cookie Banner',
                required: false,
                type: 'modular_content'
            },

            /**
             * Custom Background Image (asset)
             */
            custom_background_image: {
                codename: 'custom_background_image',
                id: '37393800-e2f6-417e-b3ea-b80cc689bc7b',
                externalId: undefined,
                name: 'Custom Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Custom CSS (asset)
             */
            custom_css: {
                codename: 'custom_css',
                id: '48ab725d-2bcf-4215-9678-f39e36e5fd5a',
                externalId: undefined,
                name: 'Custom CSS',
                required: false,
                type: 'asset'
            },

            /**
             * Favicon (asset)
             */
            favicon: {
                codename: 'favicon',
                id: '0f58deed-5ec9-43cf-a3e3-877655b40628',
                externalId: undefined,
                name: 'Favicon',
                required: false,
                type: 'asset'
            },

            /**
             * Footer Logo Overwrite (asset)
             */
            footer_logo_overwrite: {
                codename: 'footer_logo_overwrite',
                id: 'eaa589d2-dd49-4ac9-8b76-518b90712f28',
                externalId: undefined,
                name: 'Footer Logo Overwrite',
                required: false,
                type: 'asset'
            },

            /**
             * Footer Text Overwrite (text)
             */
            footer_text_overwrite: {
                codename: 'footer_text_overwrite',
                id: '0efeec00-f4fe-4ff1-9bc9-717d1f538160',
                externalId: undefined,
                name: 'Footer Text Overwrite',
                required: false,
                type: 'text'
            },

            /**
             * Global Contact Block (modular_content)
             */
            global_contact_block: {
                codename: 'global_contact_block',
                id: '2ba54ecc-f7e8-4862-b977-68b18d3b2264',
                externalId: undefined,
                name: 'Global Contact Block',
                required: false,
                type: 'modular_content'
            },

            /**
             * Global Headers (text)
             */
            global_headers: {
                codename: 'global_headers',
                id: '7d97d6f8-36b1-4188-b7de-8a1e13eabb64',
                externalId: undefined,
                name: 'Global Headers',
                required: false,
                type: 'text'
            },

            /**
             * Google Analytics (text)
             */
            google_analytics: {
                codename: 'google_analytics',
                id: '629d1de7-3f7e-4dbd-85ba-79581612abb2',
                externalId: undefined,
                name: 'Google Analytics',
                required: false,
                type: 'text'
            },

            /**
             * Google Tag Manager ID (text)
             */
            google_tag_manager_id: {
                codename: 'google_tag_manager_id',
                id: '81faf4ab-d106-4aac-a824-442c7859b9dd',
                externalId: undefined,
                name: 'Google Tag Manager ID',
                required: false,
                type: 'text'
            },

            /**
             * Hero Background Images (taxonomy)
             */
            hero_background_image: {
                codename: 'hero_background_image',
                id: '10010aac-eb6b-4c00-a05e-1bf59f02f72d',
                externalId: undefined,
                name: 'Hero Background Image',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Hide Footer (multiple_choice)
             */
            hide_footer: {
                codename: 'hide_footer',
                id: '797999c8-eb3f-46d8-816c-eb780a06526a',
                externalId: undefined,
                name: 'Hide Footer',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'c42970a8-61bc-4d7a-969e-fd785016e0c0',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '7e952180-e426-4686-b4bc-e0605ced5371',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Navigation Footer (modular_content)
             */
            navigation_footer: {
                codename: 'navigation_footer',
                id: 'e62d9f77-f898-47bb-9d8e-6994a76b246b',
                externalId: undefined,
                name: 'Navigation Footer',
                required: false,
                type: 'modular_content'
            },

            /**
             * Navigation Header (modular_content)
             */
            navigation_header: {
                codename: 'navigation_header',
                id: '90441ba3-5c43-4c29-ac04-5b242ba2f71f',
                externalId: undefined,
                name: 'Navigation Header',
                required: false,
                type: 'modular_content'
            },

            /**
             * Primary Color (text)
             */
            primary_color: {
                codename: 'primary_color',
                id: '74853ebb-961b-4b2e-81aa-e2fe90aa096c',
                externalId: undefined,
                name: 'Primary Color',
                required: false,
                type: 'text'
            },

            /**
             * Production URL (text)
             *
             * Example: https://www.projectsite.com Note: do not include "/" after the top-level domain.
             */
            production_url: {
                codename: 'production_url',
                id: '09d14ea3-3d58-4ebb-af5f-3be34b9829a7',
                externalId: undefined,
                name: 'Production URL',
                required: false,
                type: 'text'
            },

            /**
             * Redirect Enabled (multiple_choice)
             */
            redirect_enabled: {
                codename: 'redirect_enabled',
                id: '512719fd-dc6a-4c67-87ed-600e041d9a37',
                externalId: undefined,
                name: 'Redirect Enabled',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '93f054bd-3292-4329-88fb-bcb7c5cf98d0',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'ed75011b-455c-4cba-b326-80f504420722',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Robots txt (modular_content)
             */
            robots_txt: {
                codename: 'robots_txt',
                id: '547afc92-a7a3-4a59-a00d-87b6697a9935',
                externalId: undefined,
                name: 'Robots.txt',
                required: false,
                type: 'modular_content'
            },

            /**
             * Script Tags (modular_content)
             */
            script_tags: {
                codename: 'script_tags',
                id: 'f012900c-e3d4-4c23-9890-678c3ac80eb1',
                externalId: undefined,
                name: 'Script Tags',
                required: false,
                type: 'modular_content'
            },

            /**
             * Site Title (text)
             */
            site_title: {
                codename: 'site_title',
                id: '55b498ac-69c6-46b3-83de-e9ab85a45ffa',
                externalId: undefined,
                name: 'Site Title',
                required: false,
                type: 'text'
            },

            /**
             * Sitewide Notice (modular_content)
             */
            sitewide_notice: {
                codename: 'sitewide_notice',
                id: '4099953d-20ee-424b-9396-357ef487a081',
                externalId: undefined,
                name: 'Sitewide Notice',
                required: false,
                type: 'modular_content'
            },

            /**
             * Top bar Info (rich_text)
             *
             * Optional field. This field takes precedence over the fields above and should be used only when you need to customize the project’s top bar information. Separate multiple options with a pipe "|" (e.g Case Name 1 | Case Name 2).
             */
            top_bar_info: {
                codename: 'top_bar_info',
                id: '749bef05-25ba-482e-904b-635ebe7b366b',
                externalId: undefined,
                name: 'Top bar Info',
                required: false,
                type: 'rich_text'
            },

            /**
             * TrustArc Code Block (text)
             */
            trustarc_code_block: {
                codename: 'trustarc_code_block',
                id: 'f51971a5-3661-47c3-890b-657be22122ac',
                externalId: undefined,
                name: 'TrustArc Code Block',
                required: false,
                type: 'text'
            },

            /**
             * Uat URL (text)
             *
             * Example: https://test.projectsite.com Note: do not include "/" after the top-level domain.
             */
            uat_url: {
                codename: 'uat_url',
                id: '99ef6ad0-f988-46fd-b30d-fbcfd4c28420',
                externalId: undefined,
                name: 'Uat URL',
                required: false,
                type: 'text'
            },

            /**
             * Use a Hero Background Image (multiple_choice)
             */
            use_a_hero_background_image: {
                codename: 'use_a_hero_background_image',
                id: '6beedccd-9dfa-4d75-8fb7-a81dfb965ee3',
                externalId: undefined,
                name: 'Use a Hero Background Image',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'e6f3cc14-d52c-4797-8b45-af0a0490a714',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '6d7b6e36-f0dc-4920-b16d-cfca900b8e2b',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Website Logo (asset)
             */
            website_logo: {
                codename: 'website_logo',
                id: '0c648947-e34b-413b-8655-a1f9e74c6d22',
                externalId: undefined,
                name: 'Website Logo',
                required: false,
                type: 'asset'
            }
        }
    },

    /**
     *    Content Security Policy Additions
     */
    _content_security_policy: {
        codename: '_content_security_policy',
        id: '7c2fb230-0b0d-4946-b5cc-ff4e1e1e2fbb',
        externalId: undefined,
        name: '🌍 Content Security Policy Additions',
        elements: {
            /**
             * Base uri Sources (text)
             *
             * Enter the trusted base URIs that the <base> element in your HTML may point to. Each must begin with https:// and be semicolon-delimited.For example:https://my-site.orgUse of multiple base URIs is rare and often unnecessary. If you don’t know what this is for, leave it blank or contact support.These will be merged with the default base URIs coded into the application.
             */
            base_uri_sources: {
                codename: 'base_uri_sources',
                id: '5edb4daf-8724-4f1a-93a2-021f8e0ba1ac',
                externalId: undefined,
                name: 'Base-uri Sources',
                required: false,
                type: 'text'
            },

            /**
             * Connect Sources (text)
             *
             * Enter a list of acceptable domains that JavaScript may connect to via fetch, WebSockets, or other dynamic methods. Entries must be all lower-case, semi-colon delimited, and prefixed with https://. Wildcards may be used for trusted API hosts.For example:https://api.my-site.org; https://*.telemetry.trusted.net; https://events.example.comhttp, bare wildcards, and other insecure protocols are not allowed. If your API host is not reachable over HTTPS, please contact support.These will be merged with the default connect sources coded into the application.
             */
            connect_sources: {
                codename: 'connect_sources',
                id: 'aa0d7c40-c323-41b4-b02c-eb8e0138c501',
                externalId: undefined,
                name: 'Connect Sources',
                required: false,
                type: 'text'
            },

            /**
             * Font Sources (text)
             *
             * Enter a list of acceptable domains that fonts may be loaded from. Use lower-case, semi-colon delimited entries with optional trailing semicolon. Wildcards are allowed on subdomains of trusted font CDNs, and all sources must begin with https://.For example:https://fonts.gstatic.com; https://*.trusted-fonts.net; https://fonts.my-site.orgThe use of bare wildcards, http, and unsafe sources is not permitted. Contact application support if you need an exception.These will be merged with the default font sources coded into the application.
             */
            font_sources: {
                codename: 'font_sources',
                id: '7462d1a6-5718-44c7-822d-89178a231576',
                externalId: undefined,
                name: 'Font Sources',
                required: false,
                type: 'text'
            },

            /**
             * Form Action Sources (text)
             *
             * Enter the list of endpoints that form submissions are allowed to post to. All entries must be lower-case, use https://, and be semicolon-delimited.For example:https://submit.my-site.org; https://forms.trusted.netDo not include http, bare wildcards, or destinations outside your control. If you need to submit to an external processor, contact support.These will be merged with the default form actions coded into the application.
             */
            form_action_sources: {
                codename: 'form_action_sources',
                id: 'a2e9241e-fc44-44f8-9743-37390079b1f3',
                externalId: undefined,
                name: 'Form Action Sources',
                required: false,
                type: 'text'
            },

            /**
             * Frame Sources (text)
             *
             * Enter a list of domains that are allowed to be embedded in <iframe> or similar elements on your site. The list must be lower-case, semi-colon delimited, and prefixed with https://. Wildcards can be used for trusted frame providers.For example:https://www.youtube.com; https://*.widgets.safe.net; https://frames.my-site.orgDo not use http, bare wildcards, or unverified third-party sources. If an external service must be embedded, contact application support for review.These will be merged with the default frame sources coded into the application.
             */
            frame_sources: {
                codename: 'frame_sources',
                id: '9d708233-90a3-4b5a-b47c-ad00937f85e4',
                externalId: undefined,
                name: 'Frame Sources',
                required: false,
                type: 'text'
            },

            /**
             * Image Sources (text)
             *
             * Enter a list of acceptable domains that images may be loaded from. The list should be all lower-case and semi-colon delimited (with an optional trailing semicolon). You may use wildcards to include trusted subdomains (e.g. *.imgcdn.com). Always prefix each entry with https://.For example:https://images.example.com; https://*.imgcdn.com; https://assets.my-site.orgBare wildcards, trailing wildcards, and http sources are not permitted. If you need to include data URIs or other sources, please reach out to application support.These will be merged with the default image sources coded into the application.
             */
            image_sources: {
                codename: 'image_sources',
                id: '7cee7d48-1b00-40bd-9a14-1dabe2a99bae',
                externalId: undefined,
                name: 'Image Sources',
                required: false,
                type: 'text'
            },

            /**
             * Manifest Sources (text)
             *
             * Enter a list of acceptable domains that web app manifest files may be loaded from. Use https://, lowercase domains, and separate entries with semicolons.For example:https://my-site.org; https://*.cdn.my-app.nethttp and wildcard-only entries are not allowed. Manifest sources are rarely needed outside of progressive web apps. Contact support if you're unsure.These will be merged with the default manifest sources coded into the application.
             */
            manifest_sources: {
                codename: 'manifest_sources',
                id: '4019c177-d5e2-4641-a653-211d901e9980',
                externalId: undefined,
                name: 'Manifest Sources',
                required: false,
                type: 'text'
            },

            /**
             * Media Sources (text)
             *
             * Enter a list of acceptable domains that audio and video media may be loaded from. The list should be semi-colon delimited, lower-case, and use the https:// scheme. Wildcards for trusted CDNs are allowed.For example:https://media.example.com; https://*.streamsafe.net; https://video.my-site.orghttp, bare wildcards, and untrusted media sources are not permitted. Reach out to application support if you believe additional sources are required.These will be merged with the default media sources coded into the application.
             */
            media_sources: {
                codename: 'media_sources',
                id: '23e47763-e550-46be-9d18-badf6c4f5fe6',
                externalId: undefined,
                name: 'Media Sources',
                required: false,
                type: 'text'
            },

            /**
             * Object Sources (text)
             *
             * Enter a list of acceptable domains that may serve legacy plugin content such as Flash or Java (generally discouraged). All sources must use https:// and be semi-colon delimited.For example:https://safe-plugin-host.com; https://*.legacy-support.orgFlash and plugin content are deprecated in most modern browsers. Contact support before adding any object source to ensure compatibility and safety.These will be merged with the default object sources coded into the application.
             */
            object_sources: {
                codename: 'object_sources',
                id: 'd574942b-7696-4d1d-95f4-631836199418',
                externalId: undefined,
                name: 'Object Sources',
                required: false,
                type: 'text'
            },

            /**
             * Script Sources (text)
             *
             * Enter a list of acceptable domains that browsers may use to load JavaScript for this site. The list should be all lower-case and semi-colon delimited (with an optional trailing semicolon). You may use a wildcard to cover many subdomains if you trust the host domain (e.g. *.trustedcdn.com). Make sure you preface your domain with the https:// schema, even if you use a wildcard.For example:https://cdn.jsdelivr.net; https://*.trustedcdn.com; https://scripts.my-site.orgBare wildcards, trailing wildcards, http, unsafe-inline, and unsafe-eval are not allowed. If you believe you need one of those sources, please contact application support.These will be merged with the default script sources coded into the application.
             */
            project_specific_script_sources: {
                codename: 'project_specific_script_sources',
                id: '6a94eae1-ab04-43df-90fe-86e48b3912e3',
                externalId: undefined,
                name: 'Script Sources',
                required: false,
                type: 'text'
            },

            /**
             * Style Sources (text)
             *
             * Enter a list of acceptable domains that browsers may use to load CSS stylesheets. The list should be all lower-case and semi-colon delimited (with an optional trailing semicolon). You may use a wildcard to cover many subdomains if you trust the host domain (e.g. *.googleapis.com). Make sure you preface your domain with the https:// schema, even if you use a wildcard.For example:https://fonts.googleapis.com; https://*.safe-style.net; https://styles.my-site.orgBare wildcards, trailing wildcards, http, unsafe-inline, and unsafe-eval are not allowed. If you believe you need one of those sources, please contact application support.These will be merged with the default style sources coded into the application.
             */
            style_sources: {
                codename: 'style_sources',
                id: '2edc2f92-7def-4278-b254-1adcc104124e',
                externalId: undefined,
                name: 'Style Sources',
                required: false,
                type: 'text'
            },

            /**
             * Worker Sources (text)
             *
             * Enter a list of acceptable domains for loading JavaScript workers (e.g., Web Workers and Shared Workers). Use https:// and semicolon-delimit the entries.For example:https://workers.my-site.org; https://*.trusted-workers.netThis directive helps limit where background scripts can be loaded from. Avoid including dynamic or third-party domains without review.These will be merged with the default worker sources coded into the application.
             */
            worker_sources: {
                codename: 'worker_sources',
                id: 'fceadf81-4169-4721-86b5-bde259461df2',
                externalId: undefined,
                name: 'Worker Sources',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Cookie Banner
     */
    _cookie_banner: {
        codename: '_cookie_banner',
        id: '79e64b5a-57a5-4823-bc90-11b4f6bf9ddc',
        externalId: undefined,
        name: '🌍 Cookie Banner',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: 'd41c46ae-c913-4aa1-beaf-d52a3ce6d093',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '2881970a-b323-4bf7-9df7-8b65513678b8',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    EFile Project
     */
    efile_project: {
        codename: 'efile_project',
        id: 'cadfe76a-47e1-4e01-8ffa-8d7e4de6a83a',
        externalId: undefined,
        name: '🌍 EFile Project',
        elements: {
            /**
             * Deadline (date_time)
             *
             * The deadline for submission. After this date, securities cases will display language about submissions being past deadline and consumer cases will redirect to a past filing deadline message.
             */
            deadline: {
                codename: 'deadline',
                id: 'ab01342a-783b-4444-a58a-99fa5e2bfc17',
                externalId: undefined,
                name: 'Deadline',
                required: false,
                type: 'date_time'
            },

            /**
             * Domain Override (text)
             *
             * The project-specific domain associated with the email address you're using for email confirmations.
             */
            domain_override: {
                codename: 'domain_override',
                id: 'e6f29fe9-a443-48fe-a619-7f8ab5d91a60',
                externalId: undefined,
                name: 'Domain Override',
                required: false,
                type: 'text'
            },

            /**
             * Download Instructions URL (text)
             *
             * Link from the info site for the instructions on how to complete the bulk filer template.
             */
            download_instructions_url: {
                codename: 'download_instructions_url',
                id: '4bcc3b8c-8aaf-4d54-949f-cec739cff721',
                externalId: undefined,
                name: 'Download Instructions URL',
                required: false,
                type: 'text'
            },

            /**
             * Download Template URL (text)
             *
             * Link from info site for the bulk filer template.
             */
            download_template_url: {
                codename: 'download_template_url',
                id: '58aee7e5-6932-43e1-a94b-4d8e2126bf98',
                externalId: undefined,
                name: 'Download Template URL',
                required: false,
                type: 'text'
            },

            /**
             * From Address Override (text)
             *
             * The email address you would like email confirmations to be sent from. Typically, this would be efile@[project domain].com. If this is not configured, all email confirmations will be sent from info@jndefile.com
             */
            from_address_override: {
                codename: 'from_address_override',
                id: '44963830-df46-4142-856c-1c072394e208',
                externalId: undefined,
                name: 'From Address Override',
                required: false,
                type: 'text'
            },

            /**
             * Is Active (multiple_choice)
             *
             * This controls whether the project code is available at all. If set to False, securities projects will disappear from the project dropdown list and consumer projects will throw an error not found.
             */
            is_active: {
                codename: 'is_active',
                id: 'fe251766-e07a-4982-9e2d-5d4f6612d6d2',
                externalId: undefined,
                name: 'Is Active',
                required: true,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'true',
                        id: '0d30149d-96cf-4a0c-a0fa-ff05c106a614',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'false',
                        id: 'ff774333-6c0b-4809-ab6f-7955983c8406',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Production Ticket Number (text)
             */
            production_ticket_number: {
                codename: 'production_ticket_number',
                id: '1ba580ec-ac1c-4938-af4e-e139aa6fef77',
                externalId: undefined,
                name: 'Production Ticket Number',
                required: true,
                type: 'text'
            },

            /**
             * Project Code (text)
             */
            project_code: {
                codename: 'project_code',
                id: 'adb9da1b-c98b-44d9-b862-4ef0748a6bc5',
                externalId: undefined,
                name: 'Project Code',
                required: true,
                type: 'text'
            },

            /**
             * Project Short Name (text)
             *
             * This text will appear in the project dropdown for securities projects and as the case header on consumer projects.
             */
            project_short_name: {
                codename: 'project_short_name',
                id: '71348d92-a076-4c5d-beef-d3c93125c4a0',
                externalId: undefined,
                name: 'Project Short Name',
                required: true,
                type: 'text'
            },

            /**
             * Project Type (multiple_choice)
             *
             * Any securities project will appear in the dropdown list on the main page and will remain available after the filing deadline. Any consumer project will appear on its own page with the /?pc=[project code] query string endpoint. It will throw a past deadline message and submission will not be possible after the deadline.
             */
            project_type: {
                codename: 'project_type',
                id: '67482bdb-9be0-4b05-91d9-761f2b8cabd5',
                externalId: undefined,
                name: 'Project Type',
                required: true,
                type: 'multiple_choice',
                options: {
                    consumer: {
                        name: 'Consumer',
                        id: '16fbc25e-9294-4b61-a53a-9f78461a1864',
                        codename: 'consumer',
                        externalId: undefined
                    },
                    securities: {
                        name: 'Securities',
                        id: 'b5d34aa9-5de8-4d5a-a7f2-ecf7bd054214',
                        codename: 'securities',
                        externalId: undefined
                    }
                }
            },

            /**
             * Sync Active (multiple_choice)
             *
             * This should always be set to true.
             */
            sync_active: {
                codename: 'sync_active',
                id: 'c22eb1ca-7a0c-44b7-9111-563e8531a178',
                externalId: undefined,
                name: 'Sync Active',
                required: true,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'true',
                        id: '498d73ec-1a81-4c9b-a904-8cdb0e23d4f3',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'false',
                        id: '0ac0a8dc-7f65-4152-af26-e5e32195646b',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Global Navigation Item
     */
    global_navigation_item: {
        codename: 'global_navigation_item',
        id: '798be317-b322-450b-8825-0fce0fbbe1b3',
        externalId: undefined,
        name: '🌍 Global Navigation Item',
        elements: {
            /**
             * External URL (text)
             */
            external_url: {
                codename: 'external_url',
                id: 'c894179c-3033-4e1f-a2f2-b47de9096f00',
                externalId: undefined,
                name: 'External URL',
                required: false,
                type: 'text'
            },

            /**
             * Internal Link (modular_content)
             */
            internal_link: {
                codename: 'internal_link',
                id: '4709661f-e5f7-480e-a67b-452b08f33f06',
                externalId: undefined,
                name: 'Internal Link',
                required: false,
                type: 'modular_content'
            },

            /**
             * Media (modular_content)
             */
            media: {
                codename: 'media',
                id: '4f246c44-803a-4718-8bce-cea61e1bc791',
                externalId: undefined,
                name: 'Media',
                required: false,
                type: 'modular_content'
            },

            /**
             * Page (modular_content)
             */
            page: {
                codename: 'page',
                id: 'adddb814-2cfa-4a91-b87d-4f0fbd79e463',
                externalId: undefined,
                name: 'Page',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '79958581-81d5-47a3-97f0-343e74034c12',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Global Navigation Section
     */
    global_navigation_section: {
        codename: 'global_navigation_section',
        id: '24de683d-716d-415a-afdd-a03f50b92dc8',
        externalId: undefined,
        name: '🌍 Global Navigation Section',
        elements: {
            /**
             * Navigation Items (modular_content)
             */
            navigation_items: {
                codename: 'navigation_items',
                id: '0000d5c9-fdc9-4ba8-a9e1-003d08597228',
                externalId: undefined,
                name: 'Navigation Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '18efe32c-579f-472c-be91-7f1b36072a73',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Hero Background Image Item
     */
    _hero_background_image_item: {
        codename: '_hero_background_image_item',
        id: '9d82ac11-d38c-4194-bdf2-91ceef85801f',
        externalId: undefined,
        name: '🌍 Hero Background Image Item',
        elements: {
            /**
             * Background Hero Image (asset)
             */
            background_hero_image: {
                codename: 'background_hero_image',
                id: '41ac478f-f7af-4a72-ab64-a7d9ef46dbb3',
                externalId: undefined,
                name: 'Background Hero Image',
                required: false,
                type: 'asset'
            },

            /**
             * Hero Background Images (taxonomy)
             */
            related_taxonomy: {
                codename: 'related_taxonomy',
                id: 'a7206942-2cb7-4ef6-b9b4-92f68449cec1',
                externalId: undefined,
                name: 'Related Taxonomy',
                required: false,
                type: 'taxonomy'
            }
        }
    },

    /**
     *    Hero Background Images
     */
    _hero_background_images: {
        codename: '_hero_background_images',
        id: '5f3a0e4c-fc8a-4ecc-8f4a-08fe74dc33a3',
        externalId: undefined,
        name: '🌍 Hero Background Images',
        elements: {
            /**
             * Hero Background Image Options (modular_content)
             */
            hero_background_image_options: {
                codename: 'hero_background_image_options',
                id: '4396e29f-22bf-4b17-a32d-4b85e2796b13',
                externalId: undefined,
                name: 'Hero Background Image Options',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     *    Localized Strings
     */
    _localized_strings: {
        codename: '_localized_strings',
        id: 'e7b949ed-1492-4566-a46b-e1074b181905',
        externalId: undefined,
        name: '🌍 Localized Strings',
        elements: {
            /**
             * Localized String (modular_content)
             */
            localized_string: {
                codename: 'localized_string',
                id: '177adf16-3dff-4c5e-8591-1d6e7e9844fc',
                externalId: undefined,
                name: 'Localized String',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     *    OCF Deadline
     */
    ocf_deadline: {
        codename: 'ocf_deadline',
        id: 'cd1ad03b-6056-4596-b170-35aa5a4ec012',
        externalId: undefined,
        name: '🌍 OCF Deadline',
        elements: {
            /**
             * Deadline Date Time (text)
             *
             * The deadline triggers the instant the date time you enter hits. Please enter a datetime in the following format MM/DD/YYYY HH:MM:SS AM|PM. If you dynamically display the date on the front end. For example, if the front end specifies a text block "you must submit by [dynamic date]"), and this deadline is configured as 02/23/2026 11:59:59 PM, the front end text will appear as, "you must submit by February 23rd, 2026.
             */
            deadlinedate: {
                codename: 'deadlinedate',
                id: '1da50b6a-2860-457e-9654-d5e8758d6754',
                externalId: undefined,
                name: 'Deadline Date Time',
                required: false,
                type: 'text'
            },

            /**
             * Deadline Key (text)
             *
             * Obtain these values from the developer. They must match the values used by the developer. Mismatches will show up as warnings on the site at /ocfsettings.
             */
            deadline_key: {
                codename: 'deadline_key',
                id: '4ad496b3-6a75-4464-93ee-dfdbe925575d',
                externalId: undefined,
                name: 'Deadline Key',
                required: true,
                type: 'text'
            },

            /**
             * Language (multiple_choice)
             *
             * WARNING!!! If you enter the same value for deadline key and language under the same collection (for example, two deadlines for ECT each with the DeadlineKey GlobalDeadline and each with the language en, all deadlines for the project will break. A warning will be visible at the site in the project settings under /ocfsettings.
             */
            language: {
                codename: 'language',
                id: '20821645-991e-4d27-8784-5f675adf1980',
                externalId: undefined,
                name: 'Language',
                required: true,
                type: 'multiple_choice',
                options: {
                    en: {
                        name: 'en',
                        id: '24bc1ad2-fab9-43b6-b9d7-b7e19e854d16',
                        codename: 'en',
                        externalId: undefined
                    },
                    es: {
                        name: 'es',
                        id: '7b50e767-b4a2-4225-8652-e2112b25f553',
                        codename: 'es',
                        externalId: undefined
                    },
                    fr: {
                        name: 'fr',
                        id: '12b50ea8-b4b6-482b-ba9f-5b483f8caf2d',
                        codename: 'fr',
                        externalId: undefined
                    }
                }
            },

            /**
             * Redirect Url (text)
             *
             * Please include the full redirect url beginning https://
             */
            redirect_url: {
                codename: 'redirect_url',
                id: '2ceb25c1-5397-434e-b4d2-33a287020b3e',
                externalId: undefined,
                name: 'Redirect Url',
                required: true,
                type: 'text'
            },

            /**
             * Time Zone (text)
             *
             * Use Standard time zones rather than Daylight savings time zones. The OCF server will correctly parse whether to use Daylight savings time based on the Deadline's DateTime value. A listing of time zones that will be recognized can be found here: https://learn.microsoft.com/en-us/windows-hardware/manufacture/desktop/default-time-zones?view=windows-11
             */
            time_zone: {
                codename: 'time_zone',
                id: 'f3969db5-e19f-45e4-82bc-4d145d4c5d1d',
                externalId: undefined,
                name: 'Time Zone',
                required: true,
                type: 'text'
            }
        }
    },

    /**
     *    OCF Settings
     */
    ocf_settings: {
        codename: 'ocf_settings',
        id: '56f69799-187e-4ce7-aa05-b55919da4d73',
        externalId: undefined,
        name: '🌍 OCF Settings',
        elements: {
            /**
             * Deadlines (modular_content)
             */
            deadlines: {
                codename: 'deadlines',
                id: 'ca211994-5b2e-420e-bd38-80e286dd4e64',
                externalId: undefined,
                name: 'Deadlines',
                required: false,
                type: 'modular_content'
            },

            /**
             * Dev URL (text)
             */
            dev_url: {
                codename: 'dev_url',
                id: '6e64c714-2d0f-437f-af01-0de2ae5cea2f',
                externalId: undefined,
                name: 'Dev URL',
                required: false,
                type: 'text'
            },

            /**
             * Production URL (text)
             */
            production_url: {
                codename: 'production_url',
                id: '1df76f3c-7e2d-4780-aa5e-ad9a39c06652',
                externalId: undefined,
                name: 'Production URL',
                required: false,
                type: 'text'
            },

            /**
             * UAT URL (text)
             */
            uat_url: {
                codename: 'uat_url',
                id: 'bf46f4de-a013-4308-9f1c-1090aa67769e',
                externalId: undefined,
                name: 'UAT URL',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Redirect Rule
     */
    redirect_rule: {
        codename: 'redirect_rule',
        id: '2baf40de-564f-4a2c-a481-4f93c897c2b6',
        externalId: undefined,
        name: '🌍 Redirect Rule',
        elements: {
            /**
             * Source Path (text)
             *
             * Path should starts with "/" ex. "/faq"
             */
            source_path: {
                codename: 'source_path',
                id: '7a07e0b5-0297-4298-811e-aa59ff3d4b4b',
                externalId: undefined,
                name: 'Source Path',
                required: false,
                type: 'text'
            },

            /**
             * Target Path or URL (text)
             *
             * Path should starts with a "/" character, meanwhile a URL should start with "http".
             */
            target_path_or_url: {
                codename: 'target_path_or_url',
                id: 'bbc76a13-8f44-4f0f-95c1-f6dc46fc2176',
                externalId: undefined,
                name: 'Target Path or URL',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Release
     */
    _release: {
        codename: '_release',
        id: '3ffe561a-1532-4904-823e-a985319acc22',
        externalId: undefined,
        name: '🌍 Release',
        elements: {
            /**
             * Release ID (text)
             */
            release_id: {
                codename: 'release_id',
                id: '25f60b18-3587-49fd-abf4-c9156acfacdc',
                externalId: undefined,
                name: 'Release ID',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Robots txt
     */
    _robots_txt: {
        codename: '_robots_txt',
        id: 'd3aa913a-5ba3-40ac-9997-10f973e67128',
        externalId: undefined,
        name: '🌍 Robots.txt',
        elements: {
            /**
             * Robots txt File Contents (text)
             */
            robots_txt_file_contents: {
                codename: 'robots_txt_file_contents',
                id: '62612766-a53e-4771-a2cb-7e40567aad67',
                externalId: undefined,
                name: 'Robots.txt File Contents',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Script Tag
     */
    script_tag: {
        codename: 'script_tag',
        id: '85e4374b-8660-45aa-a611-abb1ea37512d',
        externalId: undefined,
        name: '🌍 Script Tag',
        elements: {
            /**
             * Inner Code (text)
             */
            inner_code: {
                codename: 'inner_code',
                id: '512b11e1-a617-41fe-972a-8d45cd2ba172',
                externalId: undefined,
                name: 'Inner Code',
                required: false,
                type: 'text'
            },

            /**
             * Location (multiple_choice)
             */
            location: {
                codename: 'location',
                id: 'b0eb230c-597d-4917-a15a-744296ca90a6',
                externalId: undefined,
                name: 'Location',
                required: true,
                type: 'multiple_choice',
                options: {
                    head: {
                        name: 'Head',
                        id: '27d907d8-7243-454a-9ef4-555c3984dffe',
                        codename: 'head',
                        externalId: undefined
                    },
                    body_open: {
                        name: 'Body Open',
                        id: '81affa1d-40d3-42c0-b5b6-1b99d4f98e9c',
                        codename: 'body_open',
                        externalId: undefined
                    },
                    body_close: {
                        name: 'Body Close',
                        id: 'e6efb730-56e7-4848-ba92-282052c02c8d',
                        codename: 'body_close',
                        externalId: undefined
                    }
                }
            },

            /**
             * URL (text)
             */
            url: {
                codename: 'url',
                id: '3a896c15-f59d-4145-9e19-8068117e09f0',
                externalId: undefined,
                name: 'URL',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Static Web App Config
     */
    _static_web_app_config: {
        codename: '_static_web_app_config',
        id: 'd0154ff4-e4aa-47d7-bb6c-2996b47a770b',
        externalId: undefined,
        name: '🌍 Static Web App Config',
        elements: {
            /**
             * Allowed IP Ranges (text)
             *
             * Separate multiple IP with a comma
             */
            allowed_ip_ranges: {
                codename: 'allowed_ip_ranges',
                id: '1a42297f-2433-40f6-b7b8-a29980de939e',
                externalId: undefined,
                name: 'Allowed IP Ranges',
                required: false,
                type: 'text'
            },

            /**
             * DEV Azure Front Door ID (text)
             */
            dev_azure_front_door_id: {
                codename: 'dev_azure_front_door_id',
                id: '283d9ac0-e266-4519-8f66-08945c603478',
                externalId: undefined,
                name: 'DEV Azure Front Door ID',
                required: false,
                type: 'text'
            },

            /**
             * PROD Azure Front Door ID (text)
             */
            prod_azure_front_door_id: {
                codename: 'prod_azure_front_door_id',
                id: '2347bd45-06e7-4295-a318-bb8545743dcd',
                externalId: undefined,
                name: 'PROD Azure Front Door ID',
                required: false,
                type: 'text'
            },

            /**
             * UAT Azure Front Door ID (text)
             */
            uat_azure_front_door_id: {
                codename: 'uat_azure_front_door_id',
                id: '19f02ab0-1f2b-4495-8546-b35effea990f',
                externalId: undefined,
                name: 'UAT Azure Front Door ID',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Translated String
     */
    _translated_string: {
        codename: '_translated_string',
        id: 'd17d35ca-8e62-443e-b324-65926f2a7f79',
        externalId: undefined,
        name: '🌍 Translated String',
        elements: {
            /**
             * Class (text)
             */
            class: {
                codename: 'class',
                id: '6b7b0525-eb41-4487-939a-cb2e93312a5e',
                externalId: undefined,
                name: 'Class',
                required: false,
                type: 'text'
            },

            /**
             * Text (text)
             */
            text: {
                codename: 'text',
                id: '4e60132d-3b6a-44a3-a863-e7a8296fe1f3',
                externalId: undefined,
                name: 'Text',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Directory Landing Page
     */
    directory_landing_page: {
        codename: 'directory_landing_page',
        id: 'b77c4ded-3f0d-44e4-9082-2d42c743909f',
        externalId: undefined,
        name: '📄 Directory Landing Page',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '8c104a13-bc42-4381-813b-93da19bf82fa',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Hero (modular_content)
             */
            hero: {
                codename: 'hero',
                id: '1a554b9b-d893-4dda-8f28-5400c9b28356',
                externalId: undefined,
                name: 'Hero',
                required: false,
                type: 'modular_content'
            },

            /**
             * Hero Overlay (modular_content)
             */
            hero_overlay: {
                codename: 'hero_overlay',
                id: '1661aaae-7285-40cb-ab2e-2e670c65dffc',
                externalId: undefined,
                name: 'Hero Overlay',
                required: false,
                type: 'modular_content'
            },

            /**
             * Homepages (subpages)
             */
            homepages: {
                codename: 'homepages',
                id: '85466624-325d-462b-b2fa-4c2dede25220',
                externalId: undefined,
                name: 'Homepages',
                required: false,
                type: 'subpages'
            },

            /**
             * Meta Description (text)
             */
            seo_metadata__meta_description: {
                codename: 'seo_metadata__meta_description',
                id: '3bf1c4f3-97b6-439c-a0ee-1025f3a47d6d',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text',

                snippetCodename: 'seo_metadata'
            },

            /**
             * OG Image (asset)
             */
            seo_metadata__og_image: {
                codename: 'seo_metadata__og_image',
                id: '196588b7-0514-44fa-9ffa-6c7a901b6abf',
                externalId: undefined,
                name: 'OG Image',
                required: false,
                type: 'asset',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Show Favicon (multiple_choice)
             */
            show_favicon: {
                codename: 'show_favicon',
                id: '6d9ce6b5-90ff-4974-a258-676610402246',
                externalId: undefined,
                name: 'Show Favicon',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '69860c29-2b86-488e-85d7-c44f601f9d04',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '2bb63c8c-c2c5-4069-b502-c4ba54bd4bbf',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Show logo (multiple_choice)
             */
            show_logo: {
                codename: 'show_logo',
                id: 'd850c900-1321-4fba-9254-040be62fd159',
                externalId: undefined,
                name: 'Show logo',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '4ad91ce1-ea49-493e-810c-4ee3c1769f6f',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'e51d006c-81b2-441f-b709-dbead7b48232',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'ac415b56-ff46-41e3-bdd8-1e5afdb4992d',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Top bar Info (rich_text)
             */
            top_bar_info: {
                codename: 'top_bar_info',
                id: 'f95ab2eb-f1a8-4bd9-b10d-e1b85e6f8921',
                externalId: undefined,
                name: 'Top bar Info',
                required: false,
                type: 'rich_text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: '695fd531-7ad7-49ed-8ef5-b22a0cece01e',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    FAQ Page
     */
    frequently_asked_questions: {
        codename: 'frequently_asked_questions',
        id: '4ef0b9d0-cc99-4468-afad-09d306cca7f7',
        externalId: undefined,
        name: '📄 FAQ Page',
        elements: {
            /**
             * Accordion Lists (modular_content)
             */
            accordion_lists: {
                codename: 'accordion_lists',
                id: '14b108ff-3151-4628-871a-547718685295',
                externalId: undefined,
                name: 'Accordion Lists',
                required: false,
                type: 'modular_content'
            },

            /**
             * Custom Background Image (asset)
             */
            custom_background_image: {
                codename: 'custom_background_image',
                id: 'b71315e6-d13e-4ebb-89e3-269d7989bf2c',
                externalId: undefined,
                name: 'Custom Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Meta Description (text)
             */
            seo_metadata__meta_description: {
                codename: 'seo_metadata__meta_description',
                id: '3bf1c4f3-97b6-439c-a0ee-1025f3a47d6d',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Numbering (multiple_choice)
             */
            numbering: {
                codename: 'numbering',
                id: '0e29bb2b-2d74-4ddb-9ccd-01c483c2d242',
                externalId: undefined,
                name: 'Numbering',
                required: false,
                type: 'multiple_choice',
                options: {
                    show: {
                        name: 'Show',
                        id: 'f8ab9721-77ce-4930-8add-6b476efc1724',
                        codename: 'show',
                        externalId: undefined
                    },
                    hide: {
                        name: 'Hide',
                        id: '44f395ed-dec2-4a3f-9ade-6605f234c91f',
                        codename: 'hide',
                        externalId: undefined
                    }
                }
            },

            /**
             * OG Image (asset)
             */
            seo_metadata__og_image: {
                codename: 'seo_metadata__og_image',
                id: '196588b7-0514-44fa-9ffa-6c7a901b6abf',
                externalId: undefined,
                name: 'OG Image',
                required: false,
                type: 'asset',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Search Placeholder Text (text)
             */
            search_placeholder_text: {
                codename: 'search_placeholder_text',
                id: 'accf76dc-7fdd-4532-a62a-1dbbae77577e',
                externalId: undefined,
                name: 'Search Placeholder Text',
                required: true,
                type: 'text'
            },

            /**
             * State on Page Load (multiple_choice)
             */
            state_on_page_load: {
                codename: 'state_on_page_load',
                id: '7fd8b9aa-570c-4198-aebc-66986580f029',
                externalId: undefined,
                name: 'State on Page Load',
                required: false,
                type: 'multiple_choice',
                options: {
                    collapsed: {
                        name: 'Collapsed',
                        id: 'c9a8f8ef-6cce-462c-901e-dd7c18e6c1e2',
                        codename: 'collapsed',
                        externalId: undefined
                    },
                    expanded: {
                        name: 'Expanded',
                        id: '6d602b4b-b531-41e6-9762-03483de26669',
                        codename: 'expanded',
                        externalId: undefined
                    }
                }
            },

            /**
             * Sub Title (text)
             */
            sub_title: {
                codename: 'sub_title',
                id: '7eeaebbc-385b-45f4-86c3-38d516a73710',
                externalId: undefined,
                name: 'Sub Title',
                required: false,
                type: 'text'
            },

            /**
             * Subpages (subpages)
             */
            subpages: {
                codename: 'subpages',
                id: '36fbd1fb-9f1a-4000-b3f3-b1c20d53850e',
                externalId: undefined,
                name: 'Subpages',
                required: false,
                type: 'subpages'
            },

            /**
             * Table of Contents (multiple_choice)
             */
            table_of_contents: {
                codename: 'table_of_contents',
                id: 'cfece743-8090-414c-b49b-7917bcb16cea',
                externalId: undefined,
                name: 'Table of Contents',
                required: false,
                type: 'multiple_choice',
                options: {
                    show: {
                        name: 'Show',
                        id: '69ae353f-dbbc-4c9d-89ab-cdb1bea60485',
                        codename: 'show',
                        externalId: undefined
                    },
                    hide: {
                        name: 'Hide',
                        id: '1f758c20-29d9-4736-9fed-4c7c2a5a279b',
                        codename: 'hide',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '964e4e1f-0871-4a8f-a0cd-b491ff1263e2',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: 'd75a6d4f-c92a-4ca4-90b9-6b2c2adc4670',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Home Page
     */
    homepage: {
        codename: 'homepage',
        id: '6fdbf1e3-3cf2-48f6-9250-e9719efe9804',
        externalId: undefined,
        name: '📄 Home Page',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '3a8caf5c-5ce3-4f14-83db-5bee33c783cd',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Footer Contact Block (modular_content)
             */
            footer_contact_block: {
                codename: 'footer_contact_block',
                id: '93bb9b97-e66f-4d68-98b3-ee6e95d3baf6',
                externalId: undefined,
                name: 'Footer Contact Block',
                required: false,
                type: 'modular_content'
            },

            /**
             * Hero (modular_content)
             */
            hero: {
                codename: 'hero',
                id: '32a8a504-57cb-4a02-b650-0e529aaa4fd9',
                externalId: undefined,
                name: 'Hero',
                required: false,
                type: 'modular_content'
            },

            /**
             * Hero Overlay (modular_content)
             */
            hero_overlay: {
                codename: 'hero_overlay',
                id: '826feaa2-eb2b-4b51-810a-89490ddb0361',
                externalId: undefined,
                name: 'Hero Overlay',
                required: false,
                type: 'modular_content'
            },

            /**
             * Meta Description (text)
             */
            seo_metadata__meta_description: {
                codename: 'seo_metadata__meta_description',
                id: '3bf1c4f3-97b6-439c-a0ee-1025f3a47d6d',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text',

                snippetCodename: 'seo_metadata'
            },

            /**
             * OG Image (asset)
             */
            seo_metadata__og_image: {
                codename: 'seo_metadata__og_image',
                id: '196588b7-0514-44fa-9ffa-6c7a901b6abf',
                externalId: undefined,
                name: 'OG Image',
                required: false,
                type: 'asset',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Subpages (subpages)
             */
            subpages: {
                codename: 'subpages',
                id: '11d8e0a4-4199-45c0-bcd4-828bd82bd409',
                externalId: undefined,
                name: 'Subpages',
                required: false,
                type: 'subpages'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '98367b9b-140a-4c4a-a78b-06f03c553dc3',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Top bar Info (rich_text)
             */
            top_bar_info: {
                codename: 'top_bar_info',
                id: '5042943b-a376-41ce-9845-481ba5a97af4',
                externalId: undefined,
                name: 'Top bar Info',
                required: false,
                type: 'rich_text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: 'dc730c3f-94ae-44b2-94d3-69c39ea91405',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Interior Page
     */
    interior_page: {
        codename: 'interior_page',
        id: '850fd55f-8f2b-4b0c-8226-ea9c4bae1fd0',
        externalId: undefined,
        name: '📄 Interior Page',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '542fd985-0985-428f-90e9-848dc7d9e467',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Hero (modular_content)
             */
            hero: {
                codename: 'hero',
                id: '2f5c0a81-2e29-4458-967d-6a201692ea04',
                externalId: undefined,
                name: 'Hero',
                required: false,
                type: 'modular_content'
            },

            /**
             * Hero Overlay (modular_content)
             */
            hero_overlay: {
                codename: 'hero_overlay',
                id: 'b29438a1-d754-49f2-928d-2bbaacef002f',
                externalId: undefined,
                name: 'Hero Overlay',
                required: false,
                type: 'modular_content'
            },

            /**
             * Meta Description (text)
             */
            seo_metadata__meta_description: {
                codename: 'seo_metadata__meta_description',
                id: '3bf1c4f3-97b6-439c-a0ee-1025f3a47d6d',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text',

                snippetCodename: 'seo_metadata'
            },

            /**
             * OG Image (asset)
             */
            seo_metadata__og_image: {
                codename: 'seo_metadata__og_image',
                id: '196588b7-0514-44fa-9ffa-6c7a901b6abf',
                externalId: undefined,
                name: 'OG Image',
                required: false,
                type: 'asset',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Show global contact block (multiple_choice)
             */
            show_global_contact_block: {
                codename: 'show_global_contact_block',
                id: '021499cd-93ec-4a3c-a7f1-5aed9596decf',
                externalId: undefined,
                name: 'Show global contact block',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '1cef0ab4-83f1-4f0a-b168-87683a4a5546',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '40c6b1e6-0ade-47cf-81da-02d588b575ee',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Subpages (subpages)
             */
            subpages: {
                codename: 'subpages',
                id: '23e9d05f-aece-42df-a5b6-4857f22f204a',
                externalId: undefined,
                name: 'Subpages',
                required: false,
                type: 'subpages'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '4c5791d7-0dec-49c7-b30d-b17070683826',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: '2d68c6cb-30a7-4926-88c9-dc70bb69db9b',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *   Site Redirect Page
     */
    site_redirect_page: {
        codename: 'site_redirect_page',
        id: '29ecf5ea-d968-4b41-ac04-1cf3be11f807',
        externalId: undefined,
        name: '📄Site Redirect Page',
        elements: {
            /**
             * Logo (asset)
             */
            logo: {
                codename: 'logo',
                id: '2337f4d9-3c46-430b-a566-f23db0b37f83',
                externalId: undefined,
                name: 'Logo',
                required: true,
                type: 'asset'
            },

            /**
             * Redirect Page Text (rich_text)
             */
            redirect_page_text: {
                codename: 'redirect_page_text',
                id: '5ec41da5-ee23-4eac-9658-65b366a97f45',
                externalId: undefined,
                name: 'Redirect Page Text',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '1685b2da-7129-40d4-8f52-55e4ff5b0f2d',
                externalId: undefined,
                name: 'Title',
                required: true,
                type: 'text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: '635fd159-1c1b-40d5-afaf-dfe9a311f4f2',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Accordion Item
     */
    accordion_item: {
        codename: 'accordion_item',
        id: 'dd8ee2f3-c672-48e3-afb8-3af790620b86',
        externalId: undefined,
        name: '🔠 Accordion Item',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '451fe247-6906-44e9-8e90-1e0a60d23fd7',
                externalId: undefined,
                name: 'Content',
                required: true,
                type: 'rich_text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '0d5ae704-4a10-4d8f-afab-3a82eb6d1784',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '2b5b2150-0c9f-423b-922a-ac7c8efc8645',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Action Item
     */
    action_item: {
        codename: 'action_item',
        id: '0aa76f28-7c0c-4900-bbb1-cc508a500b4b',
        externalId: undefined,
        name: '🔠 Action Item',
        elements: {
            /**
             * Date (date_time)
             */
            date: {
                codename: 'date',
                id: '6437de2b-dbac-4d95-98db-cc6e4fbd1347',
                externalId: undefined,
                name: 'Date',
                required: false,
                type: 'date_time'
            },

            /**
             * Date Display Option (multiple_choice)
             */
            date_display_option: {
                codename: 'date_display_option',
                id: 'ac8d95b7-6718-4af3-8304-50cc0700ae0f',
                externalId: undefined,
                name: 'Date Display Option',
                required: false,
                type: 'multiple_choice',
                options: {
                    date: {
                        name: 'Date',
                        id: 'd09feb9b-cd52-474a-822c-b7d4ba45d4c3',
                        codename: 'date',
                        externalId: undefined
                    },
                    date_and_time: {
                        name: 'Date and Time',
                        id: '9cce50d1-ef0b-4d8f-b47a-02483ef59592',
                        codename: 'date_and_time',
                        externalId: undefined
                    },
                    no_date: {
                        name: 'No Date',
                        id: 'f5e83942-4edc-4c07-b545-d9dfccea55ef',
                        codename: 'no_date',
                        externalId: undefined
                    }
                }
            },

            /**
             * Explanation (rich_text)
             */
            explanation: {
                codename: 'explanation',
                id: '45b58843-c826-4483-a57d-9790c55a1f3a',
                externalId: undefined,
                name: 'Explanation',
                required: false,
                type: 'rich_text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '6b7dd338-a3ef-4c7b-873c-0297eae0fcf5',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Status (multiple_choice)
             */
            status: {
                codename: 'status',
                id: '268080bc-ccb4-49e1-a810-cfd648ac88f8',
                externalId: undefined,
                name: 'Status',
                required: true,
                type: 'multiple_choice',
                options: {
                    no_status: {
                        name: 'No Status',
                        id: 'b0c0275f-d1b1-4422-b0ef-71c7193cfd7b',
                        codename: 'no_status',
                        externalId: undefined
                    },
                    auto: {
                        name: 'Auto',
                        id: '7a7e942c-6638-44ae-9758-8b641e5f3d70',
                        codename: 'auto',
                        externalId: undefined
                    },
                    upcoming: {
                        name: 'Upcoming',
                        id: '252b9b1f-0a70-49e7-8928-7cf819d5f76e',
                        codename: 'upcoming',
                        externalId: undefined
                    },
                    passed: {
                        name: 'Passed',
                        id: '79701640-4729-44d0-9702-f3188a54e797',
                        codename: 'passed',
                        externalId: undefined
                    },
                    held: {
                        name: 'Held',
                        id: '4d97b910-5b32-4317-a72c-406767905a51',
                        codename: 'held',
                        externalId: undefined
                    },
                    amended: {
                        name: 'Amended',
                        id: '083b5b62-03ac-46fa-af36-933b15e41c87',
                        codename: 'amended',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (rich_text)
             */
            title: {
                codename: 'title',
                id: '946df575-f760-44bb-b6ca-5160693c1211',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'rich_text'
            }
        }
    },

    /**
     *    Action Section
     */
    action_section: {
        codename: 'action_section',
        id: '60269bb7-0ce6-4598-b812-3ed6c9793cc9',
        externalId: undefined,
        name: '🔠 Action Section',
        elements: {
            /**
             * Action Items (modular_content)
             */
            action_items: {
                codename: 'action_items',
                id: 'dc6d5f71-de65-45c1-a0d0-2952696096d3',
                externalId: undefined,
                name: 'Action Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Date (date_time)
             */
            date: {
                codename: 'date',
                id: '418e0cac-1ffa-47f8-a00e-2ace0cd6e636',
                externalId: undefined,
                name: 'Date',
                required: false,
                type: 'date_time'
            },

            /**
             * Date Display Option (multiple_choice)
             */
            date_display_option: {
                codename: 'date_display_option',
                id: 'f82020a6-3633-482e-8894-ae6a6de9bbd6',
                externalId: undefined,
                name: 'Date Display Option',
                required: false,
                type: 'multiple_choice',
                options: {
                    date: {
                        name: 'Date',
                        id: '5667486b-2f0e-4d48-ab8b-2a9087c6b023',
                        codename: 'date',
                        externalId: undefined
                    },
                    date_and_time: {
                        name: 'Date and Time',
                        id: '7e3daa8e-aadd-4334-9954-f6311f4c84ce',
                        codename: 'date_and_time',
                        externalId: undefined
                    },
                    no_date: {
                        name: 'No Date',
                        id: '887e2ee3-3e53-4e3c-b144-c2e91d8695c0',
                        codename: 'no_date',
                        externalId: undefined
                    }
                }
            },

            /**
             * Explanation (rich_text)
             */
            explanation: {
                codename: 'explanation',
                id: '82d44588-4da8-4950-8846-d88c8f0b4c11',
                externalId: undefined,
                name: 'Explanation',
                required: false,
                type: 'rich_text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'c98eb370-4158-4e0b-9ba7-3b8e7527f3fc',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Status (multiple_choice)
             */
            status: {
                codename: 'status',
                id: '717bd405-4839-41fd-980b-a8f6df3df84b',
                externalId: undefined,
                name: 'Status',
                required: true,
                type: 'multiple_choice',
                options: {
                    no_status: {
                        name: 'No Status',
                        id: '5da2f7f1-c17d-4197-b3c1-3ade0d1dedab',
                        codename: 'no_status',
                        externalId: undefined
                    },
                    auto: {
                        name: 'Auto',
                        id: 'cb23f22c-b62e-4d2b-8931-5a1235321388',
                        codename: 'auto',
                        externalId: undefined
                    },
                    upcoming: {
                        name: 'Upcoming',
                        id: 'b949bed6-920d-4b44-9913-0abce57e3786',
                        codename: 'upcoming',
                        externalId: undefined
                    },
                    passed: {
                        name: 'Passed',
                        id: 'a3ff0d71-f32c-441f-9129-1b8f69cf3453',
                        codename: 'passed',
                        externalId: undefined
                    },
                    held: {
                        name: 'Held',
                        id: '92b5dff1-f2a8-415a-8534-58c98f5be8fe',
                        codename: 'held',
                        externalId: undefined
                    },
                    amended: {
                        name: 'Amended',
                        id: '34850a1d-10a0-454a-8a94-048dd49c5899',
                        codename: 'amended',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (rich_text)
             */
            title_ab74174: {
                codename: 'title_ab74174',
                id: 'ab741744-f305-4d34-80de-2fd3f2875cc1',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'rich_text'
            }
        }
    },

    /**
     *    Anchor Tag
     */
    anchor_tag: {
        codename: 'anchor_tag',
        id: '2918377f-ad8c-44b5-ac71-76e206bed6a4',
        externalId: undefined,
        name: '🔠 Anchor Tag',
        elements: {
            /**
             * ID (text)
             */
            id: {
                codename: 'id',
                id: '0533025b-6c47-490e-9215-401129ac0167',
                externalId: undefined,
                name: 'ID',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '27b11872-1265-4c34-a0bc-acdbcaa47a57',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Call to Action
     */
    call_to_action: {
        codename: 'call_to_action',
        id: '3427b8a8-7be3-4cb2-8ee0-0949f80b837a',
        externalId: undefined,
        name: '🔠 Call to Action',
        elements: {
            /**
             * Email Address (text)
             */
            email_address: {
                codename: 'email_address',
                id: '91e26c5d-79b7-4faf-b454-cfc403a2e56d',
                externalId: undefined,
                name: 'Email Address',
                required: false,
                type: 'text'
            },

            /**
             * Generic Asset Target (asset)
             */
            generic_asset_target: {
                codename: 'generic_asset_target',
                id: '2e743703-8c62-4b43-888f-a4d9f5fd0bfc',
                externalId: undefined,
                name: 'Generic Asset Target',
                required: false,
                type: 'asset'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '2dcaa07c-2335-4706-93ac-0d51b3eeb157',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Link Title (text)
             */
            link_title: {
                codename: 'link_title',
                id: '995b5629-7abe-45b3-83de-52906b9b2fcc',
                externalId: undefined,
                name: 'Link Title',
                required: false,
                type: 'text'
            },

            /**
             * Linked Target (modular_content)
             */
            linked_target: {
                codename: 'linked_target',
                id: 'ccf3c923-8659-480f-8261-10305a5b11c9',
                externalId: undefined,
                name: 'Linked Target',
                required: false,
                type: 'modular_content'
            },

            /**
             * Manual Target (text)
             */
            manual_target: {
                codename: 'manual_target',
                id: 'c9087f68-9676-4e21-910f-36c842a25c6f',
                externalId: undefined,
                name: 'Manual Target',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Claim Status
     */
    claim_status: {
        codename: 'claim_status',
        id: 'ef7d6f7a-ed46-4e68-9701-c4eb35d59f99',
        externalId: undefined,
        name: '🔠 Claim Status',
        elements: {
            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'ba302eda-48ad-4001-bf17-73cc9756e668',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Link Text (text)
             */
            link_text: {
                codename: 'link_text',
                id: 'b3a3bfd1-c4bc-4136-9647-0c5c208d3720',
                externalId: undefined,
                name: 'Link Text',
                required: false,
                type: 'text'
            },

            /**
             * Placeholder Text (text)
             */
            placeholder_text: {
                codename: 'placeholder_text',
                id: '928efe76-858f-4fce-80ee-dfa323f2793a',
                externalId: undefined,
                name: 'Placeholder Text',
                required: false,
                type: 'text'
            },

            /**
             * Status Page URL (text)
             */
            status_page_url: {
                codename: 'status_page_url',
                id: '357e9671-df5b-4d8a-b6c0-8dd1495fc5c4',
                externalId: undefined,
                name: 'Status Page URL',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Contact Block
     */
    split_content_contact_block: {
        codename: 'split_content_contact_block',
        id: '18af7716-50b7-4f0c-bd8d-237745eece5b',
        externalId: undefined,
        name: '🔠 Contact Block',
        elements: {
            /**
             * Background (multiple_choice)
             */
            styling: {
                codename: 'styling',
                id: 'bd406d50-60e7-4e3f-9c48-ce3e37f6a595',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light_grey: {
                        name: 'Light Grey',
                        id: 'a8584092-0a9b-444d-85b9-3a053be8c1ee',
                        codename: 'light_grey',
                        externalId: undefined
                    },
                    dark_grey: {
                        name: 'Dark Grey',
                        id: 'e87b1906-6b9b-48fd-ac8b-c3c3202c29e5',
                        codename: 'dark_grey',
                        externalId: undefined
                    },
                    white: {
                        name: 'White',
                        id: 'fb2a47f5-3dc0-48c1-95b6-aea8d585343d',
                        codename: 'white',
                        externalId: undefined
                    },
                    primary: {
                        name: 'Primary',
                        id: '21c8c273-ae16-4205-bc70-aa098303cb9a',
                        codename: 'primary',
                        externalId: undefined
                    }
                }
            },

            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '8402b1f1-858b-4472-94ff-cebbd314eb42',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: 'f67d0d95-87c7-4230-a2f6-a34df7e0f954',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '99ac4657-b868-430a-8c64-9bb40c822901',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Contact Item   Address
     */
    _contact_item___address: {
        codename: '_contact_item___address',
        id: '0dedc339-c8ee-476d-b3c5-c3c9400b87df',
        externalId: undefined,
        name: '🔠 Contact Item - Address',
        elements: {
            /**
             * Address (rich_text)
             */
            address: {
                codename: 'address',
                id: '8f85b0b1-3550-4948-9b67-d2549c551335',
                externalId: undefined,
                name: 'Address',
                required: false,
                type: 'rich_text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'c182d35c-4f2b-49bb-866b-f972726d4d5a',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: 'a46386da-e860-4aac-948c-63ae7e67022f',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Show Icon (multiple_choice)
             */
            show_icon: {
                codename: 'show_icon',
                id: '4e43fbb1-9403-4c6a-955a-6fae8b0a908b',
                externalId: undefined,
                name: 'Show Icon',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes_pin: {
                        name: 'Yes  location pin',
                        id: '5ccc52c2-d79c-46da-90a4-f61a8c9fdefb',
                        codename: 'yes_pin',
                        externalId: undefined
                    },
                    yes_envelope: {
                        name: 'Yes  envelope',
                        id: '4ba0b655-43fc-42cc-b77f-e343d9be09f9',
                        codename: 'yes_envelope',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'a4e42ab1-0399-4373-9997-c795167a65be',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Contact Item   Email
     */
    _contact_item___email___: {
        codename: '_contact_item___email___',
        id: '0446d9c5-0c66-41cf-97c6-d9591457a7ab',
        externalId: undefined,
        name: '🔠 Contact Item - Email',
        elements: {
            /**
             * Email Address (text)
             */
            email_address: {
                codename: 'email_address',
                id: '93d3c366-a5ef-4d7a-a5b8-3ece1999e51d',
                externalId: undefined,
                name: 'Email Address',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '81600b9c-6e21-436d-987a-88c660f53193',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: 'f10e1ae7-916a-40cc-b53b-7188cde7c054',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Show Icon (multiple_choice)
             */
            show_icon: {
                codename: 'show_icon',
                id: 'b22aad5b-6a1f-4276-834d-073b95f843f5',
                externalId: undefined,
                name: 'Show Icon',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '1d20a733-dfed-4f95-83f5-35f7c0a8e844',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '93985489-9482-40c5-9135-faa6f6f4adac',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Contact Item   Link
     */
    _contact_item___link: {
        codename: '_contact_item___link',
        id: 'da0368f5-9e1e-4496-8aa5-a2ec5bf53343',
        externalId: undefined,
        name: '🔠 Contact Item - Link',
        elements: {
            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '54ace77a-3a67-4373-9695-bcd4f493045e',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: 'cf933633-2040-4ade-b6ef-532270767a4d',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Link Address (text)
             *
             * Type a valid web URL, such as https://www.example.org
             */
            link_address: {
                codename: 'link_address',
                id: 'b990d8b8-6426-4be7-b12d-356f33d75f87',
                externalId: undefined,
                name: 'Link Address',
                required: false,
                type: 'text'
            },

            /**
             * Show Icon (multiple_choice)
             */
            show_icon: {
                codename: 'show_icon',
                id: '09be7899-a438-468a-a2cb-d13ea96cc7f7',
                externalId: undefined,
                name: 'Show Icon',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '6f12e11c-71a2-488c-b362-89b86c0c0267',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'a3606bb0-15ea-4e96-b310-41a978ae4b69',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Contact Item   Open Text
     */
    _contact_item___open_text: {
        codename: '_contact_item___open_text',
        id: 'a53da134-34bf-41d4-b7c3-1e0d30079ef4',
        externalId: undefined,
        name: '🔠 Contact Item - Open Text',
        elements: {
            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: 'c764288f-e1fc-41b4-bb3a-d01f6fa4900a',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'bb106e75-9f4d-438b-a95c-a84ef6baad9f',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: 'eabb0f49-d9a3-4a0a-b263-e947a945d4d7',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Text (rich_text)
             */
            text: {
                codename: 'text',
                id: '48930e72-7349-4f57-93c9-83a93cc3765d',
                externalId: undefined,
                name: 'Text',
                required: false,
                type: 'rich_text'
            }
        }
    },

    /**
     *    Contact Item   Phone
     */
    _contact_item__phone__: {
        codename: '_contact_item__phone__',
        id: '863ce6b3-d1ef-44cf-ae93-6ed56cc572ea',
        externalId: undefined,
        name: '🔠 Contact Item - Phone',
        elements: {
            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: '5f31f040-a831-471d-a4e2-7b2458f4b424',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '78c61708-34df-46a0-b637-4cb42275714c',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: '8a8c1703-7218-4c37-8397-103d3055b984',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Phone Number (text)
             */
            phone: {
                codename: 'phone',
                id: '68b2746a-9f86-4461-9a5f-14ca04deafe9',
                externalId: undefined,
                name: 'Phone Number',
                required: false,
                type: 'text'
            },

            /**
             * Show Icon (multiple_choice)
             */
            show_icon: {
                codename: 'show_icon',
                id: '9549db5a-f6cc-40f6-83ed-3c8e94a8da56',
                externalId: undefined,
                name: 'Show Icon',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '58467299-de96-4d58-836c-21533a47a6e3',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '2910d0ef-0262-451d-93f2-25cc7acb7178',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Content   Alert Block
     */
    content_alert_block: {
        codename: 'content_alert_block',
        id: 'f6909a98-5ca2-4581-b404-a7b030eb56a6',
        externalId: undefined,
        name: '🔠 Content - Alert Block',
        elements: {
            /**
             * Alert Text (rich_text)
             */
            alert_text: {
                codename: 'alert_text',
                id: '7a709d01-b009-4e7f-8f65-87eb06265784',
                externalId: undefined,
                name: 'Alert Text',
                required: true,
                type: 'rich_text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '3074b884-4307-4fd8-ae4d-64ef8837eb66',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Styling (multiple_choice)
             */
            styling: {
                codename: 'styling',
                id: 'ff4b6219-ca9a-485b-b8c7-26aaecc5ed4d',
                externalId: undefined,
                name: 'Styling',
                required: false,
                type: 'multiple_choice',
                options: {
                    green: {
                        name: 'Green',
                        id: '3bf17eb1-8a0d-48aa-a65a-e280085fa781',
                        codename: 'green',
                        externalId: undefined
                    },
                    yellow: {
                        name: 'Yellow',
                        id: '1b0af15f-dd93-4367-aa17-43882b96a59a',
                        codename: 'yellow',
                        externalId: undefined
                    },
                    red: {
                        name: 'Red',
                        id: '52c3806c-13f7-41b1-8dd2-29a31f3cf7e6',
                        codename: 'red',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Content   Aligned Text
     */
    _content___aligned_text: {
        codename: '_content___aligned_text',
        id: '947e1b10-dd43-4fee-be6d-3018bfc643af',
        externalId: undefined,
        name: '🔠 Content - Aligned Text',
        elements: {
            /**
             * Alignment (multiple_choice)
             */
            alignment: {
                codename: 'alignment',
                id: '7a928ce6-dfc8-430c-a3a6-a34fc00ad2a1',
                externalId: undefined,
                name: 'Alignment',
                required: true,
                type: 'multiple_choice',
                options: {
                    left: {
                        name: 'Left',
                        id: '76d5dbd3-6a18-4d75-a502-08429159066f',
                        codename: 'left',
                        externalId: undefined
                    },
                    center: {
                        name: 'Center',
                        id: 'b0012fed-cb66-4b4b-9cfe-a3b2d85b5c79',
                        codename: 'center',
                        externalId: undefined
                    },
                    right: {
                        name: 'Right',
                        id: '199483f6-01ab-4a49-9d86-d3ca660e6ef9',
                        codename: 'right',
                        externalId: undefined
                    },
                    justified: {
                        name: 'Justified',
                        id: '2d87f16c-f0d8-483e-95b9-98b180948c22',
                        codename: 'justified',
                        externalId: undefined
                    }
                }
            },

            /**
             * Indentation (multiple_choice)
             */
            indentation: {
                codename: 'indentation',
                id: '1db6d0a3-3cde-4b1b-881a-fb006fbcf503',
                externalId: undefined,
                name: 'Indentation',
                required: false,
                type: 'multiple_choice',
                options: {
                    level_1: {
                        name: 'Level 1',
                        id: 'cfba432b-f554-4dfd-91ed-7fdc10a20bba',
                        codename: 'level_1',
                        externalId: undefined
                    },
                    level_2: {
                        name: 'Level 2',
                        id: 'deec8a19-3a65-4c27-b575-aa6fc3e85e4a',
                        codename: 'level_2',
                        externalId: undefined
                    },
                    level_3: {
                        name: 'Level 3',
                        id: 'b443eefe-8af9-4ae3-b112-31969a498a36',
                        codename: 'level_3',
                        externalId: undefined
                    }
                }
            },

            /**
             * Text (rich_text)
             */
            text: {
                codename: 'text',
                id: '781dfb4c-2c4a-4cef-90ca-ac5f0e25e742',
                externalId: undefined,
                name: 'Text',
                required: true,
                type: 'rich_text'
            }
        }
    },

    /**
     *    Content   Formatted Text
     */
    formatted_text: {
        codename: 'formatted_text',
        id: 'f6a9d2f2-6c60-4d6d-b88b-33d6f84cbc05',
        externalId: undefined,
        name: '🔠 Content - Formatted Text',
        elements: {
            /**
             * Bold (multiple_choice)
             */
            bold: {
                codename: 'bold',
                id: '32ae17da-0f7e-47fe-b8ab-4bd98db049f0',
                externalId: undefined,
                name: 'Bold',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'ea938c39-a970-4efb-bab1-3145b86b7dbb',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'e83dc79b-9d42-4dca-b753-cd600ec6fcd3',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Color (multiple_choice)
             */
            color: {
                codename: 'color',
                id: 'de3e97cf-82d0-45fb-a4b1-b361b8773fc8',
                externalId: undefined,
                name: 'Color',
                required: false,
                type: 'multiple_choice',
                options: {
                    red: {
                        name: 'Red',
                        id: 'c25cb7d1-82aa-4705-a064-b95ee0e8dcaa',
                        codename: 'red',
                        externalId: undefined
                    },
                    primary_color: {
                        name: 'Primary Color',
                        id: 'b48fe48d-5aa7-4a55-baae-09e7bd53bc89',
                        codename: 'primary_color',
                        externalId: undefined
                    }
                }
            },

            /**
             * Display text (text)
             */
            display_text: {
                codename: 'display_text',
                id: 'a8b3cb07-308e-467f-9b29-008f5ceb46c2',
                externalId: undefined,
                name: 'Display text',
                required: false,
                type: 'text'
            },

            /**
             * Italic (multiple_choice)
             */
            italic: {
                codename: 'italic',
                id: '6eb556bc-a898-4320-8a6a-6bcd2da3dafd',
                externalId: undefined,
                name: 'Italic',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'abb78e70-c504-4e0e-a19f-e4c24ee2342b',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '67b6a84e-29d0-4340-9ffa-a6d4b73cdd7f',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Link (text)
             */
            link: {
                codename: 'link',
                id: '58b240b2-75d9-44a3-9db0-b26e02ed378d',
                externalId: undefined,
                name: 'Link',
                required: false,
                type: 'text'
            },

            /**
             * Underlined (multiple_choice)
             */
            underlined: {
                codename: 'underlined',
                id: '7b308481-bbc3-435f-8914-0e3aa6dd6831',
                externalId: undefined,
                name: 'Underlined',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'a4ba5f9d-48ae-46ac-9f1d-d1a0bb9f9a49',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '3ade0406-8dcf-4f68-98ac-c2e6923db372',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Content   HR
     */
    _content___hr: {
        codename: '_content___hr',
        id: 'd1fdcb5f-1d5d-4144-b8ff-ebeb33fb9712',
        externalId: undefined,
        name: '🔠 Content - HR',
        elements: {}
    },

    /**
     *    Content   Image Wrap
     */
    content_image_wrap: {
        codename: 'content_image_wrap',
        id: 'f625c536-ee57-4bec-abf8-c8ebbbd0a823',
        externalId: undefined,
        name: '🔠 Content - Image Wrap',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '56ce1af3-bdbe-4816-b127-878b2af08027',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: '4e78a47d-1fa5-46c4-911c-277191ecd4a7',
                externalId: undefined,
                name: 'Image',
                required: false,
                type: 'asset'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'cf3e96ee-99bc-4bee-ac95-2f27b40d387c',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Layout (multiple_choice)
             */
            layout: {
                codename: 'layout',
                id: 'f7dd24e0-9a50-45d2-91a4-9399e856dbae',
                externalId: undefined,
                name: 'Layout',
                required: false,
                type: 'multiple_choice',
                options: {
                    left: {
                        name: 'Left',
                        id: 'a9bec334-d319-4685-86bd-0dfad76386b3',
                        codename: 'left',
                        externalId: undefined
                    },
                    right: {
                        name: 'Right',
                        id: 'ae734339-7aa2-4192-b450-587c37932614',
                        codename: 'right',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Document
     */
    document: {
        codename: 'document',
        id: '2d5e43ad-15b4-4e3a-b456-2692f29b0815',
        externalId: undefined,
        name: '🔠 Document',
        elements: {
            /**
             * Child Items (modular_content)
             */
            child_items: {
                codename: 'child_items',
                id: '018bc842-36e6-412c-95d7-01f1dc4d7c0b',
                externalId: undefined,
                name: 'Child Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Date (date_time)
             */
            date: {
                codename: 'date',
                id: '5f0f6193-a02d-4d00-a2f7-673594c715c8',
                externalId: undefined,
                name: 'Date',
                required: false,
                type: 'date_time'
            },

            /**
             * External Link (text)
             */
            external_link: {
                codename: 'external_link',
                id: 'fbb6bdcd-e41e-45be-b859-19c1d5ef692c',
                externalId: undefined,
                name: 'External Link',
                required: false,
                type: 'text'
            },

            /**
             * File (asset)
             */
            file: {
                codename: 'file',
                id: '83d640ef-671d-49be-b245-72718598ce30',
                externalId: undefined,
                name: 'File',
                required: false,
                type: 'asset'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'a1e0e9df-29a7-4f20-b55f-db6c1c345ccc',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '9c7b0305-0c3f-444c-a991-56cd2923877f',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Type (multiple_choice)
             */
            type: {
                codename: 'type',
                id: 'ae850368-cfd1-4e64-871e-e402289941f3',
                externalId: undefined,
                name: 'Type',
                required: false,
                type: 'multiple_choice',
                options: {
                    pdf: {
                        name: 'PDF',
                        id: '0e926450-12f8-4c30-836a-e803d32a8024',
                        codename: 'pdf',
                        externalId: undefined
                    },
                    word: {
                        name: 'Word',
                        id: '3dd323d5-beb8-465e-befd-af3a7c270e8f',
                        codename: 'word',
                        externalId: undefined
                    },
                    excel: {
                        name: 'Excel',
                        id: 'b33274c8-5425-419b-80bc-c6f0cb271f91',
                        codename: 'excel',
                        externalId: undefined
                    },
                    external_link: {
                        name: 'External Link',
                        id: '74dc6b0d-8a92-4ab7-bfe9-1c795cc4248c',
                        codename: 'external_link',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Download Block
     */
    split_content_downloads: {
        codename: 'split_content_downloads',
        id: 'ca14128b-3b80-40e0-b001-d82c8680c479',
        externalId: undefined,
        name: '🔠 Download Block',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '772b242e-10f0-4d99-9619-6d139e29f361',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Documents (modular_content)
             */
            documents: {
                codename: 'documents',
                id: 'd14232bb-fc45-4c02-9ce5-c9b2136a571f',
                externalId: undefined,
                name: 'Documents',
                required: false,
                type: 'modular_content'
            },

            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: '2a0fa50f-4f1c-4c7b-a4e9-920544539c8a',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '736144a3-6ae3-41e8-a0f4-87637d0281ca',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '5cf6274d-fcfa-4efd-9f54-7cd5cbd3c345',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Internal Link
     */
    internal_link: {
        codename: 'internal_link',
        id: 'd2a38035-66b6-4f2c-99d3-b8fe2248ef61',
        externalId: undefined,
        name: '🔠 Internal Link',
        elements: {
            /**
             * Element (modular_content)
             */
            element: {
                codename: 'element',
                id: '65cafe2c-d135-47b0-b386-05ca55cc0460',
                externalId: undefined,
                name: 'Element',
                required: true,
                type: 'modular_content'
            },

            /**
             * Page (modular_content)
             */
            page: {
                codename: 'page',
                id: '7224de78-4d3a-4bbe-8347-5c50502e48ca',
                externalId: undefined,
                name: 'Page',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     *    Reference
     */
    _reference: {
        codename: '_reference',
        id: '895fe81a-39c3-4797-be82-1a29984977a9',
        externalId: undefined,
        name: '🔠 Reference',
        elements: {
            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'cb98a639-3619-4f5a-a94d-2666ddcd2382',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Reference Order Number (number)
             */
            reference_order_number: {
                codename: 'reference_order_number',
                id: 'd94bf941-0e9b-45a3-ab90-bc512e2decdf',
                externalId: undefined,
                name: 'Reference Order Number',
                required: false,
                type: 'number'
            },

            /**
             * Reference Text (rich_text)
             */
            reference_text: {
                codename: 'reference_text',
                id: '98564dea-0742-462d-be8b-a54da13981b1',
                externalId: undefined,
                name: 'Reference Text',
                required: false,
                type: 'rich_text'
            }
        }
    },

    /**
     *    Accordion List
     */
    accordion_list: {
        codename: 'accordion_list',
        id: 'e8ddcb99-98f2-4a2b-9fc8-92d74b73d8bd',
        externalId: undefined,
        name: '🧩 Accordion List',
        elements: {
            /**
             * Accordion Items (modular_content)
             */
            accordion_items: {
                codename: 'accordion_items',
                id: 'c6082695-e868-4c3a-ae59-0bc81a1120fa',
                externalId: undefined,
                name: 'Accordion Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: '8e3b9ecc-f08d-48d2-a22b-c0b0a8d9f5f1',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '9a739932-1a5e-43e2-8f42-3f3c7c19bd3e',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Subtitle (rich_text)
             */
            subtitle: {
                codename: 'subtitle',
                id: '416ba8da-d31e-4ae1-94f0-a23b5ab5a5c2',
                externalId: undefined,
                name: 'Subtitle',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '3781f725-3b3b-42a5-8d64-c1fae8745c4d',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Action Table
     */
    action_table: {
        codename: 'action_table',
        id: '29655202-4ce8-482b-a8e0-8ad0a5df27ea',
        externalId: undefined,
        name: '🧩 Action Table',
        elements: {
            /**
             * Action Sections (modular_content)
             */
            action_sections: {
                codename: 'action_sections',
                id: '398f08a5-12d5-4893-9860-f889075883a5',
                externalId: undefined,
                name: 'Action Sections',
                required: false,
                type: 'modular_content'
            },

            /**
             * Background (multiple_choice)
             */
            background: {
                codename: 'background',
                id: '9754bc39-9609-471a-9f9a-98769129c14e',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: 'e4a9a1a6-ed90-4c0d-bab3-c887b5cc04f6',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: 'a19cf339-f881-433a-9aab-106b5f7698ab',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Column 1 (text)
             */
            column_1: {
                codename: 'column_1',
                id: 'e89cf62b-81b0-4c25-a10a-71ac8ea9a0d7',
                externalId: undefined,
                name: 'Column 1',
                required: false,
                type: 'text'
            },

            /**
             * Column 2 (text)
             */
            column_2: {
                codename: 'column_2',
                id: '387a0ee8-37e2-414d-a8d2-50b7afe97f73',
                externalId: undefined,
                name: 'Column 2',
                required: false,
                type: 'text'
            },

            /**
             * Column 3 (text)
             */
            column_3: {
                codename: 'column_3',
                id: '9ca87b28-d7bb-4837-acdc-ffc52f48d2df',
                externalId: undefined,
                name: 'Column 3',
                required: false,
                type: 'text'
            },

            /**
             * CSS Class (text)
             */
            css_class: {
                codename: 'css_class',
                id: 'f15f4775-ee61-439c-bd8d-e217c9b3ba62',
                externalId: undefined,
                name: 'CSS Class',
                required: false,
                type: 'text'
            },

            /**
             * Description (rich_text)
             */
            description: {
                codename: 'description',
                id: 'ea7e2a1a-e536-45bb-b2c5-6a3ada0338e5',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'rich_text'
            },

            /**
             * Footer Text (rich_text)
             */
            footer_text: {
                codename: 'footer_text',
                id: 'd3b54d85-2e74-44e4-a5c9-cd3d685a0a6b',
                externalId: undefined,
                name: 'Footer Text',
                required: false,
                type: 'rich_text'
            },

            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: '544986d3-772f-4283-a3f4-55cf717dd643',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '871b9881-8b07-42bd-872e-4db09e772b8e',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '512caa3d-0f46-4f43-bdd2-dd576df96a6b',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Contact Form
     */
    contact_form: {
        codename: 'contact_form',
        id: 'cb9e4008-98fa-49aa-8a8a-1767f20eed83',
        externalId: undefined,
        name: '🧩 Contact Form',
        elements: {
            /**
             * Address Change Option (multiple_choice)
             */
            address_change_option: {
                codename: 'address_change_option',
                id: 'e0b9f71b-5afb-4c0e-89e8-c45480113006',
                externalId: undefined,
                name: 'Address Change Option',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '64bf34b1-17f8-44e8-832a-8c9b58784d60',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '7ce77c27-d7e1-4c91-881f-60f3d894c19a',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Background (multiple_choice)
             */
            background: {
                codename: 'background',
                id: 'cec533f3-ad3b-4115-8456-303461abede9',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: '63ba76d4-2b00-4d53-a2e2-776285e3ffab',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: '874e7393-64a5-4783-8c17-b66621ada372',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '064aa108-4fdd-472b-abbe-05a3f29a9f10',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'cee6e478-7861-42e1-8802-87d305c1884b',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'fc76d7aa-3ca5-419f-b414-f28ad3c41b48',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No Top Padding',
                        id: 'ef893845-d5a8-495b-9c85-dcf42ea0c82f',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No Bottom Padding',
                        id: '936d9afa-98af-431e-8dd2-bf498124e49c',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '03252a60-b13c-4604-8c49-4a5eb7dafe0b',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Content Block
     */
    basic_content_block: {
        codename: 'basic_content_block',
        id: 'a51d7702-9edd-45b7-81ee-869aa025e0d1',
        externalId: undefined,
        name: '🧩 Content Block',
        elements: {
            /**
             * Background (multiple_choice)
             *
             * The background is white if (none) is selected.
             */
            background: {
                codename: 'background',
                id: 'b4d174ae-8723-46dd-9bf2-147be2e79cd0',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light Grey',
                        id: 'd0ef4a4d-1310-4f98-9f87-3ae7eaf8e576',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark Grey',
                        id: 'd2db4256-9c99-4951-bea1-cd58321069e2',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Column Width (multiple_choice)
             *
             * Select the width of the columns. (None) is a single column, the full width of the screen.
             */
            block_styling: {
                codename: 'block_styling',
                id: 'bb2340d3-1e5b-4de1-8778-423043069a68',
                externalId: undefined,
                name: 'Column Width',
                required: false,
                type: 'multiple_choice',
                options: {
                    n70_30: {
                        name: '70 30',
                        id: '0746ea88-b5f0-4905-afbd-f657a8332c3c',
                        codename: 'n70_30',
                        externalId: undefined
                    },
                    n60_40: {
                        name: '60 40',
                        id: '46b1f2cd-30a0-4a86-8a5c-b224acc96175',
                        codename: 'n60_40',
                        externalId: undefined
                    },
                    n50_50: {
                        name: '50 50',
                        id: '000a3f66-c9b7-45fd-b3c9-8e46cd6eaa90',
                        codename: 'n50_50',
                        externalId: undefined
                    },
                    n40_60: {
                        name: '40 60',
                        id: '5cedc531-cfb4-4401-8e55-bd085bc2d2a7',
                        codename: 'n40_60',
                        externalId: undefined
                    },
                    n30_70: {
                        name: '30 70',
                        id: '9bf97972-159f-4efe-be0b-df2b47dedd25',
                        codename: 'n30_70',
                        externalId: undefined
                    }
                }
            },

            /**
             * CSS Class (text)
             */
            css_class: {
                codename: 'css_class',
                id: '5bba7aca-136a-408c-99ca-b21f562c6121',
                externalId: undefined,
                name: 'CSS Class',
                required: false,
                type: 'text'
            },

            /**
             * Full or Left Content (rich_text)
             */
            full_or_left_content: {
                codename: 'full_or_left_content',
                id: '92c5ae28-c009-4a56-91ff-42599e0b2e05',
                externalId: undefined,
                name: 'Full or Left Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: '3ef49442-e9a0-4293-8f4e-a27c7e9a75b5',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'c0ae1488-f429-412f-8a3b-c1655854f0de',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Mobile Styling (multiple_choice)
             */
            mobile_styling: {
                codename: 'mobile_styling',
                id: '269ecb52-d1d5-4b11-a9ce-2141aa1aee98',
                externalId: undefined,
                name: 'Mobile Styling',
                required: false,
                type: 'multiple_choice',
                options: {
                    left_content_on_top: {
                        name: 'Left Content on Top',
                        id: 'd63c8ec1-39d4-4c8e-9a7d-19adefceaeee',
                        codename: 'left_content_on_top',
                        externalId: undefined
                    },
                    right_content_on_top: {
                        name: 'Right Content on Top',
                        id: 'e4062b11-d91e-4d86-b638-ae513a9f1e3f',
                        codename: 'right_content_on_top',
                        externalId: undefined
                    }
                }
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'fc76d7aa-3ca5-419f-b414-f28ad3c41b48',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No Top Padding',
                        id: 'ef893845-d5a8-495b-9c85-dcf42ea0c82f',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No Bottom Padding',
                        id: '936d9afa-98af-431e-8dd2-bf498124e49c',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Right Content (rich_text)
             */
            right_content: {
                codename: 'right_content',
                id: 'cbf05a80-b181-4060-8412-be02837cca2b',
                externalId: undefined,
                name: 'Right Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Right Title (text)
             */
            right_title: {
                codename: 'right_title',
                id: '61a76cff-faf8-47db-9c68-d85a088d7b47',
                externalId: undefined,
                name: 'Right Title',
                required: false,
                type: 'text'
            },

            /**
             * Right Title Icon (text)
             */
            right_title_icon: {
                codename: 'right_title_icon',
                id: '61a420e0-53c0-462b-ab51-03783f0fb043',
                externalId: undefined,
                name: 'Right Title Icon',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '3fddfdb6-9c69-492e-982f-146285f5cbef',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Document List
     */
    document_list: {
        codename: 'document_list',
        id: '412e43d5-646f-4af5-971e-322b8a2e72f9',
        externalId: undefined,
        name: '🧩 Document List',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '0c7101a5-4138-4960-906c-dfdc92317aae',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Documents (modular_content)
             */
            documents: {
                codename: 'documents',
                id: '96f179b0-6ce2-495d-a65e-e9863436c4ee',
                externalId: undefined,
                name: 'Documents',
                required: false,
                type: 'modular_content'
            },

            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: '6daed7b8-2f69-4918-a551-7ec01aeba458',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'b88cdaca-6694-44ca-8fa8-75d3d54fa68f',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '6fd491b0-8ae9-4026-8b11-e50b8e9c2294',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Footer Contact Block
     */
    contact_block: {
        codename: 'contact_block',
        id: '47289fa6-c4d6-4f3f-aba7-22ca3e024873',
        externalId: undefined,
        name: '🧩 Footer Contact Block',
        elements: {
            /**
             * Contact Items (modular_content)
             */
            contact_item: {
                codename: 'contact_item',
                id: '06860814-c192-4bf6-a155-9d8dcd5cc7d2',
                externalId: undefined,
                name: 'Contact Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Contact List Title (text)
             */
            contact_list_title: {
                codename: 'contact_list_title',
                id: '790cd275-793f-447a-b816-4bb52a8687bf',
                externalId: undefined,
                name: 'Contact List Title',
                required: false,
                type: 'text'
            },

            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '89b1577e-02c4-41cd-95b0-00eb790ae126',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Icon (text)
             */
            icon: {
                codename: 'icon',
                id: '32bd67a4-fab7-4f74-bffe-4c6a20b5c4a8',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '2a1966c3-24fa-4af7-90cc-a933076f69e7',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'fc76d7aa-3ca5-419f-b414-f28ad3c41b48',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No Top Padding',
                        id: 'ef893845-d5a8-495b-9c85-dcf42ea0c82f',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No Bottom Padding',
                        id: '936d9afa-98af-431e-8dd2-bf498124e49c',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Sub Title (text)
             */
            sub_title: {
                codename: 'sub_title',
                id: '6e752c33-1457-476e-9e67-3452957fc4fb',
                externalId: undefined,
                name: 'Sub Title',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '7c7335ca-8c26-4172-8e48-ef974ce1b4bd',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Full Width Card
     */
    full_width_card: {
        codename: 'full_width_card',
        id: '92a542aa-dc32-42e4-9f69-1fb508be768f',
        externalId: undefined,
        name: '🧩 Full Width Card',
        elements: {
            /**
             * Background (multiple_choice)
             */
            background: {
                codename: 'background',
                id: '31d81e55-f5fc-44fc-8fd6-fd852e66cbf5',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: '0904faca-8fb7-4359-bec9-32e612b053cd',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: '52683b49-e443-4b10-9118-2a5b4da12eae',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '2cc0d0ed-6144-47ea-9917-d85439d39df2',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'c035ddea-8dc4-4da7-b824-826931c3d976',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'fc76d7aa-3ca5-419f-b414-f28ad3c41b48',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No Top Padding',
                        id: 'ef893845-d5a8-495b-9c85-dcf42ea0c82f',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No Bottom Padding',
                        id: '936d9afa-98af-431e-8dd2-bf498124e49c',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Sub Title (text)
             */
            sub_title: {
                codename: 'sub_title',
                id: 'f536f9c1-2358-4573-ae0b-5a89b1690185',
                externalId: undefined,
                name: 'Sub Title',
                required: false,
                type: 'text'
            },

            /**
             * Text Color (multiple_choice)
             */
            text_color: {
                codename: 'text_color',
                id: 'e7e8bf6f-8846-44a6-8067-2ce6857c3cf3',
                externalId: undefined,
                name: 'Text Color',
                required: false,
                type: 'multiple_choice',
                options: {
                    primary_color: {
                        name: 'Primary Color',
                        id: '7e2b3be3-8e0e-4d56-9804-58aaa17a9038',
                        codename: 'primary_color',
                        externalId: undefined
                    },
                    black: {
                        name: 'Black',
                        id: 'ca2a9236-9cab-4c2a-91b7-bf50c41fbe3f',
                        codename: 'black',
                        externalId: undefined
                    },
                    red: {
                        name: 'Red',
                        id: 'cd699ca9-7734-419a-9181-45e5ba0d4242',
                        codename: 'red',
                        externalId: undefined
                    },
                    green: {
                        name: 'Green',
                        id: '373a4d2f-9794-4239-8783-f1738242726f',
                        codename: 'green',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '24ae6437-2133-4f92-a805-9acaabf8e5f5',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Hero
     */
    hero: {
        codename: 'hero',
        id: '23d0760d-4ea6-437b-9b3c-796986750779',
        externalId: undefined,
        name: '🧩 Hero',
        elements: {
            /**
             * Call to Action (modular_content)
             */
            call_to_action: {
                codename: 'call_to_action',
                id: '90f4a0f6-9d72-4038-a3bc-25b71a176392',
                externalId: undefined,
                name: 'Call to Action',
                required: false,
                type: 'modular_content'
            },

            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '80a26b00-17c5-4786-85ab-f3f8e3db3467',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Custom Background Image (asset)
             */
            custom_background_image: {
                codename: 'custom_background_image',
                id: 'dd68a2ec-fb9c-46ee-83f9-239c6131941e',
                externalId: undefined,
                name: 'Custom Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: '43b95a22-e64d-4e9a-a6ef-d9a9c74a2398',
                externalId: undefined,
                name: 'Image',
                required: false,
                type: 'asset'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '22ca3353-c59b-419b-a25b-3ff3b8e78566',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '270dc3d1-340d-4ea9-a73d-4318edfeb016',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Hero Overlay Card
     */
    hero_overlay_card: {
        codename: 'hero_overlay_card',
        id: '6b66c7ba-d9fa-458d-b127-8ef87d06c14b',
        externalId: undefined,
        name: '🧩 Hero Overlay Card',
        elements: {
            /**
             * Add Bottom Padding (multiple_choice)
             */
            add_bottom_padding: {
                codename: 'add_bottom_padding',
                id: 'c05a7f6b-f683-42b8-9afd-82a2c36896cc',
                externalId: undefined,
                name: 'Add Bottom Padding',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '1a92db50-6217-4fd4-a5a3-f2b509359453',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '0b5da2d7-f14b-433f-8ef0-0e1219963ed0',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Background (multiple_choice)
             *
             * The background is white if (none) is selected.
             */
            background: {
                codename: 'background',
                id: '05f90b48-01f3-4ed8-b5ef-e3184f216517',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light Grey',
                        id: '3a4b5106-0ec1-442b-90c6-e89315593f06',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark Grey',
                        id: 'f4dca71a-a04f-42b7-a2c8-f2e306e4f874',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Call to Action (modular_content)
             */
            call_to_action: {
                codename: 'call_to_action',
                id: '17571b15-d6fd-4e56-9e95-b4658c8cfd96',
                externalId: undefined,
                name: 'Call to Action',
                required: false,
                type: 'modular_content'
            },

            /**
             * Content (text)
             */
            content: {
                codename: 'content',
                id: '39132a12-78be-4523-8624-5a15b7b1c158',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'text'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: 'b21026cc-4e07-42ea-9876-5bd19985d2f4',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Sub Title (text)
             */
            sub_title: {
                codename: 'sub_title',
                id: 'c80e64cf-2abd-4857-ba5f-72e398673cbd',
                externalId: undefined,
                name: 'Sub Title',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '79d3f7de-84c7-4ba8-8b4d-aa407b557709',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Image Block
     */
    full_width_image: {
        codename: 'full_width_image',
        id: '9213d1f0-7b19-4bd0-96ca-6bb30fbd8c1f',
        externalId: undefined,
        name: '🧩 Image Block',
        elements: {
            /**
             * Caption (rich_text)
             */
            caption: {
                codename: 'caption',
                id: '7ed7fcb5-bbd5-467d-9668-ebfa705a9e58',
                externalId: undefined,
                name: 'Caption',
                required: false,
                type: 'rich_text'
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: '055fe1c0-e4f5-44cc-9c98-c735e09dfa73',
                externalId: undefined,
                name: 'Image',
                required: false,
                type: 'asset'
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '6ec5c3c6-463f-40ed-bc9f-36ea69266d58',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Mobile Image (asset)
             */
            mobile_image: {
                codename: 'mobile_image',
                id: 'e537e450-ed19-441c-8f6f-045fb3637296',
                externalId: undefined,
                name: 'Mobile Image',
                required: false,
                type: 'asset'
            }
        }
    },

    /**
     *    Reference List
     */
    _reference_list: {
        codename: '_reference_list',
        id: '30ceeb07-2a80-42e3-9b3a-2ed17be51f5c',
        externalId: undefined,
        name: '🧩 Reference List',
        elements: {
            /**
             * Default State (multiple_choice)
             */
            default_state: {
                codename: 'default_state',
                id: 'fe2700f7-5dc7-4213-8929-dc0c518806b0',
                externalId: undefined,
                name: 'Default State',
                required: false,
                type: 'multiple_choice',
                options: {
                    expanded: {
                        name: 'Expanded',
                        id: 'fe733b3d-d1b4-40e5-b5fe-fba73edb580a',
                        codename: 'expanded',
                        externalId: undefined
                    },
                    collapsed: {
                        name: 'Collapsed',
                        id: '94cbdec5-f2a0-41f7-8793-31a547f7e5f9',
                        codename: 'collapsed',
                        externalId: undefined
                    }
                }
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '7e4f6fdc-dbb2-4fea-8404-37ccd8126af9',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '42cf3c65-db17-4af2-b167-c9748183c8cd',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Sitewide Notice
     */
    sitewide_notice: {
        codename: 'sitewide_notice',
        id: '82f51cc0-431e-4736-9f21-46570855d784',
        externalId: undefined,
        name: '🧩 Sitewide Notice',
        elements: {
            /**
             * Color (multiple_choice)
             */
            color: {
                codename: 'color',
                id: '2fff1674-b008-4ef9-8f59-579696ffb3d9',
                externalId: undefined,
                name: 'Color',
                required: false,
                type: 'multiple_choice',
                options: {
                    default: {
                        name: 'Default',
                        id: '5f8f4971-40a3-4011-9560-2ea136d5ed0c',
                        codename: 'default',
                        externalId: undefined
                    },
                    primary_color: {
                        name: 'Primary Color',
                        id: '19651740-6cab-48b5-85d1-0999d73f89b8',
                        codename: 'primary_color',
                        externalId: undefined
                    },
                    red: {
                        name: 'Red',
                        id: '4632a126-2b28-49f1-9df1-9873cb8ce9bb',
                        codename: 'red',
                        externalId: undefined
                    }
                }
            },

            /**
             * Item Name (text)
             */
            item_name: {
                codename: 'item_name',
                id: '387c4454-b65a-4067-884e-0634999c7a38',
                externalId: undefined,
                name: 'Item Name',
                required: false,
                type: 'text'
            },

            /**
             * Notice State (multiple_choice)
             */
            notice_state: {
                codename: 'notice_state',
                id: '28578ff4-f677-41fc-ac7d-53777decc831',
                externalId: undefined,
                name: 'Notice State',
                required: false,
                type: 'multiple_choice',
                options: {
                    open_by_default: {
                        name: 'Open by Default',
                        id: '4593aedc-d3cb-458b-a57e-f454c57effa9',
                        codename: 'open_by_default',
                        externalId: undefined
                    },
                    closed_by_default: {
                        name: 'Closed by Default',
                        id: '4e6e31ca-3685-4385-bd51-29ed8f948073',
                        codename: 'closed_by_default',
                        externalId: undefined
                    }
                }
            },

            /**
             * Notice Text (rich_text)
             */
            notice_text: {
                codename: 'notice_text',
                id: '891d3d65-a302-4217-9da4-ad45677578d6',
                externalId: undefined,
                name: 'Notice Text',
                required: false,
                type: 'rich_text'
            }
        }
    },

    /**
     * Web spotlight root
     */
    web_spotlight_root: {
        codename: 'web_spotlight_root',
        id: '0bf1f8ec-5699-489f-9b37-fc5fcc37178e',
        externalId: undefined,
        name: 'Web spotlight root',
        elements: {
            /**
             * Content (modular_content)
             */
            content: {
                codename: 'content',
                id: '29ea0ba7-a364-4b99-bff2-0dde560c87a5',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'modular_content'
            },

            /**
             * Subpages (subpages)
             */
            subpages: {
                codename: 'subpages',
                id: '2b28be3a-8131-4cf3-9e33-42245ffc60f5',
                externalId: undefined,
                name: 'Subpages',
                required: false,
                type: 'subpages'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '59f006fe-5fbb-4518-b36b-de04b3ba871b',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    }
} as const;
